import React from "react";
import { RxCross1 } from "react-icons/rx";
import { useMsal } from "@azure/msal-react";
const FeedbackModal = ({
  isOpen,
  onClose,
  onSubmit,
  msg,
  messages,
  setFeedback,
  feedback,
  type,
}) => {
  const { accounts } = useMsal();
  const userData = accounts[0];

  const name = localStorage.getItem("userName");

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-30 flex justify-center items-center">
      <div
        className="
        flex flex-col gap-2
      bg-white 
      w-[90%] max-w-[600px] 
      max-h-[80vh] h-auto 
      rounded-md shadow-lg 
      overflow-y-auto
    "
      >
        <div className="w-full flex justify-between items-start gap-2 px-3 pb-2 pt-2.5 border-b border-[#EEEEEE]">
          <div className="w-full flex flex-col gap-1">
            {type ? (
              <h2 className="text-[18px] text-[#242424] font-tungsten-medium">
                Tailored advice/clarification.
              </h2>
            ) : (
              <h2 className="text-[18px] text-[#242424] font-tungsten-medium">
                Provide feedback, or help us to improve this response
              </h2>
            )}
            {type ? (
              <p className="text-[14px] text-[#242424]">
                Hi {name}, Please enter your query below and one of our
                specialist team members will contact you shortly.
              </p>
            ) : (
              <p className="text-[14px] text-[#242424]">
                Hi {name}, please let us know what didn’t work so we can make it
                better.
              </p>
            )}
          </div>
          <button onClick={onClose} className="text-gray-600 text-xl font-bold">
            <RxCross1 size={16} />
          </button>
        </div>
        <div className="flex flex-col gap-2 px-3 pt-2">
          <p className="text-[14px] text-[#242424] font-normal">Type Here</p>

          <div className="relative w-full">
            <textarea
              className={`w-full h-28 border border-gray-300 placeholder:text-[#616161] rounded-md outline-none p-2 text-sm resize-none ${
                feedback.length === 500 ? "text-gray-400" : "text-[#242424]"
              }`}
              placeholder="Type here"
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
              maxLength={500}
            />

            <span className="absolute bottom-2 right-2 text-[12px] text-[#656565]">
              {feedback.length}/500
            </span>
          </div>
        </div>
        <div className="flex justify-start gap-2 px-3 pb-2.5 pt-2 bg-[#F9F9F9]">
          <button
            onClick={onClose}
            className="px-3.5 py-1.5 text-[14px] text-[#242424] border border-[#C8C8C8] rounded-md"
          >
            Cancel
          </button>
          <button
            onClick={onSubmit}
            className="px-3.5 py-1.5 text-[14px] bg-[#00AEEF] hover:bg-[#2e82a0] text-white rounded-md"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeedbackModal;
